// tfa.js
const state = {
  username: '',
  password: '',
  secretKey: ''
}

const mutations = {
  setUserData (state, { username, password, secretKey, qrCodeUrl }) {
    state.username = username
    state.password = password
    state.secret_key = secretKey
    state.qr_code_url = qrCodeUrl
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/tfa.js